<template lang="pug">
  .div
    .columns
      .column.is-4
        .field
          input#inp1.is-checkradio(type='checkbox' v-model='cargador' :disabled="isDisabled")
          label.is-size-6(for='inp1') Cargador
      .column.is-4
        .field
          input#inp2.is-checkradio(type='checkbox' v-model='backpack' :disabled="isDisabled")
          label.is-size-6(for='inp2') Backpack
      .column.is-4
        .field
          input#inp3.is-checkradio(type='checkbox' v-model='caja' :disabled="isDisabled")
          label.is-size-6(for='inp3') Caja
    .columns
      .column.is-4
        .field
          input#inp4.is-checkradio(type='checkbox' v-model='mouse' :disabled="isDisabled")
          label.is-size-6(for='inp4') Mouse
      .column.is-4
        .field
          input#inp5.is-checkradio(type='checkbox' v-model='funda' :disabled="isDisabled")
          label.is-size-6(for='inp5') Funda
      .column.is-4
        .field
          input#inp6.is-checkradio(type='checkbox' v-model='accesorios' :disabled="isDisabled")
          label.is-size-6(for='inp6') Accesorios
    .columns(v-show="!isEditing")
      .column.is-3
        a.button.is-warning.is-block(@click="editar")
          | Editar 
    .columns(v-show="isEditing")
      .column.is-3
        a.button.is-block(@click="cancelEdit")
          | Cancelar 
      .column.is-3
        a.button.is-black.is-block(@click="saveItems")
          | Actualizar 
</template>

<script>
  export default {
    name: 'ListItems_Computo_Edit',
    props: {
      dataItemsBd: {
        type: Object,
        default: () => {}
      },
      desHabilitar: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        cargador: null,
        backpack: null,
        caja: null,
        mouse: null,
        funda: null,
        accesorios: null,
        itemsSelected: {},
        isDisabled: false,
        isEditing: false
      }
    },
    watch: {
      dataItemsBd() {
        if (Object.keys(this.dataItemsBd).length > 0) {
          this.cargador = this.dataItemsBd.cargador
          this.backpack = this.dataItemsBd.backpack
          this.caja = this.dataItemsBd.caja
          this.mouse = this.dataItemsBd.mouse
          this.funda  = this.dataItemsBd.funda
          this.accesorios  = this.dataItemsBd.accesorios
        }
      },
      desHabilitar() {
        if (this.desHabilitar) {
          console.log('deshabilitar true')
          this.isDisabled = true
        } else {
          console.log('deshabiliatr false')
          this.isDisabled = false
        }
        this.isEditing = false
      }
    },
    methods: {
      saveItems() {
        let myObj = {
          cargador: this.cargador,
          backpack: this.backpack,
          caja: this.caja,
          mouse: this.mouse,
          funda: this.funda,
          accesorios: this.accesorios
        }
        this.isDisabled = true
        this.itemsSelected = Object.assign({}, this.itemsSelected, myObj)
        this.$emit('itemsSelected_Comp', myObj)
      },
      editar() {
        this.isEditing = true
        this.isDisabled = false
      },
      cancelEdit() {
        this.isDisabled = true
        this.isEditing = false
        this.$emit('itemsSelected_Comp', 'close')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/Listitems_Computo_Edit.vue